"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trafficControllPatchNotificationSettingsAction = exports.patchNotificationSettingsAction = exports.receiveNotification = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var constants_1 = require("./constants");
exports.receiveNotification = (0, typesafe_actions_1.createStandardAction)(constants_1.RECEIVE_NOTIFICATION)();
exports.patchNotificationSettingsAction = (0, typesafe_actions_1.createStandardAction)(constants_1.PATCH_NOTIFICATION_SETTINGS)();
exports.trafficControllPatchNotificationSettingsAction = (0, typesafe_actions_1.createStandardAction)(constants_1.TRAFFIC_CONTROL_PATCH_NOTIFICATION_SETTINGS)();